
import { ValueType } from 'recharts/types/component/DefaultTooltipContent';

export const formatCurrency = (value: any): string => {
  if (typeof value === 'number') {
    return new Intl.NumberFormat('en-NZ', {
      style: 'currency',
      currency: 'NZD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  } else if (typeof value === 'string' && !isNaN(parseFloat(value))) {
    return new Intl.NumberFormat('en-NZ', {
      style: 'currency',
      currency: 'NZD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(parseFloat(value));
  } else if (value === null || value === undefined) {
    return '$0.00';
  }
  return `$${value}`;
};

// Helper function specifically for Recharts tooltips that handles ValueType
export const formatTooltipCurrency = (value: ValueType): string => {
  if (value === null || value === undefined) {
    return '$0.00';
  }
  
  if (typeof value === 'number') {
    return new Intl.NumberFormat('en-NZ', {
      style: 'currency',
      currency: 'NZD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }
  
  // For string values, try to parse as number
  if (typeof value === 'string') {
    const num = parseFloat(value);
    if (!isNaN(num)) {
      return new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num);
    }
    return `$${value}`;
  }
  
  // Fallback for any other type
  return `$${value}`;
};
